module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "killerFeatureSelfHealing.db589f7d.png";